/**
 * @generated SignedSource<<400d3acdaf037cbbbd5fd96f562564b0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type SalesforceInstanceType = "NOTE" | "TASK";
import { FragmentRefs } from "relay-runtime";
export type SendNotesModal_viewer$data = {
  readonly account: {
    readonly allowExternalNoteSharing: boolean;
    readonly billingAccount: {
      readonly hasAccessToHubspotFeature: boolean;
      readonly hasAccessToNotesIntegrationExport: boolean;
      readonly hasAccessToSalesforceFeature: boolean;
      readonly hasAccessToZapierIntegration: boolean;
    };
    readonly integrations: {
      readonly hubspot: {
        readonly userConnected: boolean;
      } | null;
      readonly zoomBot: {
        readonly isConnected: boolean;
      } | null;
    };
  };
  readonly googleDocsConnected: boolean | null;
  readonly integrations: {
    readonly confluence: {
      readonly id: string;
      readonly isConnected: boolean;
      readonly requiresReconnect: boolean;
    } | null;
    readonly google: {
      readonly isActive: boolean;
    } | null;
    readonly hubspot: {
      readonly id: string;
      readonly isConnected: boolean;
    } | null;
    readonly notion: {
      readonly id: string;
      readonly isConnected: boolean;
    } | null;
    readonly office365: {
      readonly id: string;
    } | null;
    readonly salesforce: {
      readonly enhancedNotesEnabled: boolean;
      readonly id: string;
      readonly isConnected: boolean;
      readonly lastUsedSalesforceInstanceType: SalesforceInstanceType;
    } | null;
    readonly zapier: {
      readonly hasNotePushHook: boolean | null;
      readonly isConnected: boolean;
    } | null;
  };
  readonly user: {
    readonly isGuest: boolean;
  };
  readonly " $fragmentType": "SendNotesModal_viewer";
};
export type SendNotesModal_viewer$key = {
  readonly " $data"?: SendNotesModal_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"SendNotesModal_viewer">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isConnected",
  "storageKey": null
},
v2 = [
  (v0/*: any*/),
  (v1/*: any*/)
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SendNotesModal_viewer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "user",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isGuest",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "googleDocsConnected",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "UserIntegrations",
      "kind": "LinkedField",
      "name": "integrations",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "OfficeUserNode",
          "kind": "LinkedField",
          "name": "office365",
          "plural": false,
          "selections": [
            (v0/*: any*/)
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "ZapierUserNode",
          "kind": "LinkedField",
          "name": "zapier",
          "plural": false,
          "selections": [
            (v1/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasNotePushHook",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "SalesforceUserNode",
          "kind": "LinkedField",
          "name": "salesforce",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            (v1/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "lastUsedSalesforceInstanceType",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "enhancedNotesEnabled",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "HubspotUserNode",
          "kind": "LinkedField",
          "name": "hubspot",
          "plural": false,
          "selections": (v2/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "GoogleUserNode",
          "kind": "LinkedField",
          "name": "google",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isActive",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "NotionUserNode",
          "kind": "LinkedField",
          "name": "notion",
          "plural": false,
          "selections": (v2/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "ConfluenceUserNode",
          "kind": "LinkedField",
          "name": "confluence",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            (v1/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "requiresReconnect",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Account",
      "kind": "LinkedField",
      "name": "account",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "allowExternalNoteSharing",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "AccountIntegrations",
          "kind": "LinkedField",
          "name": "integrations",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "HubspotAccountNode",
              "kind": "LinkedField",
              "name": "hubspot",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "userConnected",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "ZoomBotNode",
              "kind": "LinkedField",
              "name": "zoomBot",
              "plural": false,
              "selections": [
                (v1/*: any*/)
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "BillingAccount",
          "kind": "LinkedField",
          "name": "billingAccount",
          "plural": false,
          "selections": [
            {
              "alias": "hasAccessToHubspotFeature",
              "args": [
                {
                  "kind": "Literal",
                  "name": "feature",
                  "value": "hubspot_integration"
                }
              ],
              "kind": "ScalarField",
              "name": "hasAccessToFeature",
              "storageKey": "hasAccessToFeature(feature:\"hubspot_integration\")"
            },
            {
              "alias": "hasAccessToSalesforceFeature",
              "args": [
                {
                  "kind": "Literal",
                  "name": "feature",
                  "value": "salesforce_integration"
                }
              ],
              "kind": "ScalarField",
              "name": "hasAccessToFeature",
              "storageKey": "hasAccessToFeature(feature:\"salesforce_integration\")"
            },
            {
              "alias": "hasAccessToZapierIntegration",
              "args": [
                {
                  "kind": "Literal",
                  "name": "feature",
                  "value": "zapier_integration"
                }
              ],
              "kind": "ScalarField",
              "name": "hasAccessToFeature",
              "storageKey": "hasAccessToFeature(feature:\"zapier_integration\")"
            },
            {
              "alias": "hasAccessToNotesIntegrationExport",
              "args": [
                {
                  "kind": "Literal",
                  "name": "feature",
                  "value": "notes_integration_export"
                }
              ],
              "kind": "ScalarField",
              "name": "hasAccessToFeature",
              "storageKey": "hasAccessToFeature(feature:\"notes_integration_export\")"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
})();

(node as any).hash = "cd322ab42195a6304d3d34b7b46700ae";

export default node;
